<template>
  <div id="performance-pdf">
    <div class="ld-top-container">
      <MemberInfoPdf />
      <PerformanceGraph />
    </div>
    <UnitDetails />
    <div class="ld-bottom-container">
      <CycleTable />
      <PastAlertsTable />
    </div>
  </div>
</template>

<script>
import CycleTable from '@shared/components/leadDetailPdf/performance/CycleTable.vue';
import PastAlertsTable from '@shared/components/leadDetailPdf/performance/PastAlertsTable.vue';
import MemberInfoPdf from '@shared/components/leadDetailPdf/shared/MemberInfoPdf.vue';
import PerformanceGraph from '@shared/components/leadDetailPdf/performance/PerformanceGraph.vue';
import UnitDetails from '@shared/components/leadDetailPdf/performance/UnitDetails.vue';

export default {
  name: 'PerformanceAlertPdf',
  components: {
    CycleTable,
    PastAlertsTable,
    MemberInfoPdf,
    PerformanceGraph,
    UnitDetails,
  },
};
</script>
